import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import yourSquadHeadline from "../assets/headlines/your-squad.png";
import WithMotion from "../utils/withMotion";
import { Squad } from "../components/Squad";
import scss from "./Timer.module.scss";

const MS_IN_HOUR = 60 * 60 * 1000;
const MS_IN_MINUTE = 60 * 1000;
const FILM_RUNNING_TIME = 140 * MS_IN_MINUTE;

let startTime;
let endTime;

const Timer = () => {
  const [now, setNow] = useState(Date.now());
  const { squadSubmission, theater } = useSelector((state: any) => state);
  const { squad } = squadSubmission;

  if (!startTime) {
    try {
      const pinEntered = localStorage.getItem("pinEntered");
      if (pinEntered) {
        startTime = new Date(Number(pinEntered));
      } else {
        startTime = new Date();
      }
      endTime = new Date(startTime.valueOf() + FILM_RUNNING_TIME);
      (window as any).analytics?.track("Countdown", {
        countdown_start: startTime.toISOString(),
        countdown_end: endTime.toISOString(),
      });
    } catch (err) {
      console.log(err);
    }
  }

  const diff = endTime.valueOf() - now;
  const hours = Math.floor(diff / MS_IN_HOUR);
  const minutes = Math.floor((diff % MS_IN_HOUR) / MS_IN_MINUTE);
  const seconds = Math.floor(((diff % MS_IN_HOUR) % MS_IN_MINUTE) / 1000);
  const pad = (num: number) => {
    return num < 10 ? `0${num}` : num;
  };

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(Date.now());
    }, 500);
    return () => {
      window.clearInterval(interval);
    };
  }, []);

  if (diff <= 0) {
    return <Redirect to="/your-score" />;
  }

  const handleSkip = () => {
    (window as any).analytics?.track("Skip", {
      countdown_start: startTime.toISOString(),
      countdown_end: endTime.toISOString(),
      countdown_skipped: new Date().toISOString(),
      theater,
    });
  };

  return (
    <main>
      <img className={scss.headline} src={yourSquadHeadline} alt="your squad" />
      <Squad squad={squad} />
      <p className={scss.tooAttached}>DON'T GET TOO ATTACHED</p>
      <time className={scss.countdownTimer}>
        {hours}:{pad(minutes)}:{pad(seconds)}
      </time>
      <p style={{ fontFamily: "Montserrat", fontWeight: "bold", fontSize: 16 }}>
        UNTIL WE SEE WHO SURVIVED.
      </p>
      <div className={scss.skip}>
        <p>Finished watching the film?</p>
        <Link to="/your-score" onClick={handleSkip}>
          Skip to Final Score
        </Link>
      </div>
    </main>
  );
};

export default WithMotion(Timer);
